import moment from 'moment';
import React from 'react';
import { Modal } from 'react-bootstrap';
import Moment from 'react-moment';

function GochiKidUseGroupTimeErrorModal(props) {
  return (
    <Modal
      show={props.show}
      centered
      className="modal-use clr-000000 gochi-kid-receipt-confirm-modal"
    >
      <Modal.Body className="font-gothic">
        <div className="fs-20 font-weight-bold mt-4 mb-2">
          支援元の「{props.groupName}」は、利用受付を終了いたしました
        </div>

        <div className='fs-18 pb-2'>
          誠に申し訳ございませんが、選択された支援元「
          <span className='font-weight-bold'>{props.groupName}</span>
          」の利用受付は
          <span className='font-weight-bold'>{props.endTime ? moment(props.endTime).format('YYYY/MM/DD HH:mm') : ''}</span>
          をもって終了いたしました。
          <br />
          ご利用に関心をお寄せいただき、誠にありがとうございました。
        </div>

        <button
          className="btn btn-green-38 bg-red mt-4 mb-4"
          onClick={() => {
            window.location.href = props.gotoUrl
          }}
        >
          マイページに戻る
        </button>
      </Modal.Body>
    </Modal>
  );
}

export default GochiKidUseGroupTimeErrorModal;